import AWS from "aws-sdk";
import { Auth } from "aws-amplify";

const currentUserAttributes = `
  {
    User_Id
    First_Name
    Last_Name
    Cognito_Id
    Email
    Phone
    Last_Login
    User_Type{
      Title
    }
    Organizations{
      Organization_Id
      Account{
        Account_Id
      }
    }
    Permissions{
      Permission_Id
      Account_Id
      Organization_Id
      Student_Id
      Subject_Id
    }
    Starred_Students{
      Student_Id
    }
    Starred_Subjects{
      Subject_Id
    }
  }
  `;

const user = {
  createNewUser: async function(userToCreate) {
    const query = `
      mutation($cognitoId: String!, $firstName: String!, $lastName: String!, $email: String!, $phone: String!, $userTypeId: Int! ) {
        CreateUser(cognitoId: $cognitoId, firstName: $firstName, lastName: $lastName, email: $email, phone: $phone, userTypeId: $userTypeId) {
          User_Id
        }
      }`;
    const variables = {
      cognitoId: userToCreate.Cognito_Id,
      firstName: userToCreate.First_Name,
      lastName: userToCreate.Last_Name,
      email: userToCreate.Email,
      phone: userToCreate.Phone,
      userTypeId: 1
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      userToCreate.User_Id = res.data.CreateUser.User_Id;
      return userToCreate;
    });
  },

  updateUser: async function(userToUpdate) {
    const query = `
      mutation($userId: Int!, $firstName: String!, $lastName: String!, $email: String!, $phone: String!, $userTypeId: Int! ) {
        UpdateUser(userId: $userId, firstName: $firstName, lastName: $lastName, email: $email, phone: $phone, userTypeId: $userTypeId) {
          User_Id
        }
      }`;
    const variables = {
      userId: parseInt(userToUpdate.User_Id),
      firstName: userToUpdate.First_Name,
      lastName: userToUpdate.Last_Name,
      email: userToUpdate.Email,
      phone: userToUpdate.Phone,
      userTypeId: 1
    };
    return this.$store.getters.fetcher({ query, variables }).then(() => {
      return userToUpdate;
    });
  },

  createUserOrganization: async function(userId, organizationId) {
    const query = `
      mutation($userId: Int!, $organizationId: Int!) {
        CreateUserOrganization(userId: $userId, organizationId: $organizationId) {
          User_Organization_Id
        }
      }`;
    const variables = {
      userId: parseInt(userId),
      organizationId: parseInt(organizationId)
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.CreateUserOrganization.User_Organization_Id);
  },

  updateLastLogin: async function() {
    var view = this;
    return await view.$store.getters
      .fetcher({
        query: `mutation($userId: Int!, $lastLogin: Date!){
        UpdateUserLastLogin(userId: $userId, lastLogin: $lastLogin){
          Last_Login
        }
      }`,
        variables: {
          userId: parseInt(view.$store.getters.user.User_Id),
          lastLogin: Date()
        }
      })
      .then(lastLoginUpdate => {
        var user = Object.assign({}, view.$store.getters.user);
        user.Last_Login = lastLoginUpdate.data.UpdateUserLastLogin.Last_Login;
        view.$store.commit("updateUser", user);
        return true;
      });
  },

  loadUser: async function(cognitoId) {
    var view = this;
    await view.$store.getters
      .fetcher({
        query:
          `{
        GetUserByCognito(cognitoId: "` +
          cognitoId +
          `")` +
          currentUserAttributes +
          `}`
      })
      .then(res => {
        view.$store.commit("updateUser", res.data.GetUserByCognito);
      });
  },

  getUserByEmail: async function(email) {
    var view = this;
    return await view.$store.getters
      .fetcher({
        query:
          `{
        GetUserByEmail(email: "` +
          email +
          `"){
          User_Id
          First_Name
          Last_Name
          Permissions{
            Permission_Id
            Account_Id
            Organization_Id
            Student_Id
            Subject_Id
          }
        }
      }`
      })
      .then(res => res.data.GetUserByEmail);
  },

  confirmNewUser: async function(newAuthUser) {
    var view = this;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials(
      view.$store.getters.awsCreds
    );
    AWS.config.region = "us-east-1";
    await AWS.config.credentials.refresh(async () => {
      var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();
      var confirmParams = {
        UserPoolId: view.$store.getters.userPoolId,
        Username: newAuthUser.user.username
      };
      cognitoidentityserviceprovider.adminConfirmSignUp(
        confirmParams,
        (err, data) => {
          if (err) {
            console.log("Admin confirm sign up error: " + err, err.stack);
          } else {
            console.log("Admin confirm sign up success: " + data); // successful response
          }
        }
      );
    });
    return newAuthUser;
  },

  emailNewUser: function(newUser, password) {
    var lambda = new AWS.Lambda();
    var params = {
      FunctionName: "SpecialData_SendConfirmationEmail",
      InvocationType: "Event",
      Payload: JSON.stringify({
        newUserEmail: newUser.Email,
        newUserName: newUser.First_Name,
        newUserLink:
          "https://www.myspecialdata.com/#/confirmuser/" +
          newUser.User_Id +
          "/p/" +
          password
      })
    };
    lambda.invoke(params, function(err) {
      if (err) {
        console.log(err, err.stack);
      }
    });
  },

  signUpNewUser: async function(newEmail, password) {
    return await Auth.signUp({
      username: newEmail.toLowerCase(),
      password: password,
      attributes: {
        email: newEmail.toLowerCase()
      }
    })
      .then(newAuthUser => newAuthUser)
      .catch(e => console.log(e));
  },

  queryUsers: async function(organizationIds, accountIds) {
    return await this.$store.getters
      .fetcher({
        query: `query($accountIds: [Int], $organizationIds: [Int]){
        QueryUsers(accountIds: $accountIds, organizationIds: $organizationIds)
          {
            User_Id
            First_Name
            Last_Name
            Permissions{
              User_Permission_Id
              Permission_Id
              Account_Id
              Organization_Id
              Student_Id
              Subject_Id
            }
          }
        }`,
        variables: {
          accountIds: accountIds ? accountIds.map(i => parseInt(i)) : null,
          organizationIds: organizationIds
            ? organizationIds.map(o => parseInt(o))
            : null
        }
      })
      .then(res => res.data.QueryUsers);
  }
};

export { user };
